import React from "react";
import {
    Accordion,
    AccordionSummary,
    Typography,
    AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import * as Scroll from "react-scroll";

const Conditions = (props) => {
    let scroll = Scroll.animateScroll;

    React.useEffect(() => {
        scroll.scrollToTop();
    }, []);

    return (
        <div className="row">
            <div className="w-100 p-0" id="contact-div">
                <div className="container w-100 h-100 d-flex align-items-center">
                    <h1 className="text-white">
                        <b>قوانین و مقررات</b>
                    </h1>
                </div>
            </div>

            <div className="container h-auto " style={{ marginBlock: "3rem" }}>
                <div className="container pt-5 bg-white landings-container">
                    <h2
                        className="p-4 col-6 col-md-3"
                        style={{ borderBottom: "2.3px solid #6dd06d" }}
                    >
                        <b>شرایط و ضوابط عمومی</b>
                    </h2>
                    <div className="mt-10 mb-20 d-block d-md-flex">
                        <div className="col-12" style={{ fontSize: "16px" }}>
                            <>
                                مسافر ایباس؛ لطفا موارد زیر را با دقت مطالعه کنید:
                                ثبت نام و وارد کردن اطلاعات کاربری شما، رزرو یا خرید محصول به معنای آگاه بودن و پذیرفتن کلیه شرایط و قوانین سایت ایباس می باشد.
                                لازم به ذکر است شرایط و قوانین مندرج در وب‎سایت توافقی بین شرکت و کاربران ایباس می باشد. ایباس تابع <a href="https://dotic.ir/">قوانین جمهوری اسلامی ایران</a> و مقررات سازمان حمل و نقل جاده ای، سازمان میراث فرهنگی، <a href="https://cyberpolice.ir/page/2581">قانون تجارت الکترونیک</a> و <a href="https://qavanin.ir/Law/PrintText/123407">قانون جرائم رایانه ای</a> می باشد.
                            </>
                            <>
                                هر گونه سوءاستفـاده از اطلاعات از این وب‌سایت پیگرد قانونی دارد. ذکر مطالب این وب‌سایت در بستر فضای دیجیتال ، تنها با ذکر نام و نشانی اینترنتی وب‌سایت ایباس و لینک به مطلب ذکر شده مجاز بوده و در رسانه‌های کاغذی، با کسب اجازه‌ی کتبی از مسئولان وب‌سایت قابل چاپ می‎باشد.
                            </>
                        </div>
                    </div>
                </div>
                <div className="container pt-5 mt-15 bg-white landings-container">
                    <h2
                        className="p-4 col-6 col-md-5"
                        style={{ borderBottom: "2.3px solid #6dd06d" }}
                    >
                        <b>شرایط و قوانین استفاده از خدمات ایباس</b>
                    </h2>
                    <div className="mt-10 mb-20 d-block d-md-flex">
                        <div className="col-12" style={{ fontSize: "16px" }}>
                            <p>
                            از آنجاییکه
                            <br/>
                            - طرفین قصد دارند در راستای این قرارداد و در طول مدت مورد توافق با یکدیگر همکاری داشته باشند؛
                            <br/>
                            - شرکت قصد بازاریابی، جذب مسافر، آموزش خدمه طرف دوم، کسب مجوزهای قانونی لازم و پشتیبانی در
                            راستای انجام موضوع قرارداد را دارد ؛
                            <br/>
                            - مالک یا طرف دوم قصد واگذاری منافع انحصاری وسیله نقلیه خود در راستای انجام موضوع قرارداد، ارایه
                            خدمات به مسافران در طول مسیرها بر اساس استانداردهای مورد قبول طرف شرکت را دارد؛
                            </p>
                            <p>
                            اصطلاحاتی که در این شرایط و قوانین به کار رفته است دارای معانی مشروح زیر است :
                            <br/>
                            <ol type="1">
                            <li>
                             شرکت: شرکت راهکار سفر سروین که نسبت به ارائه خدمات ایباس اقدام میکند .
                            </li>
                            <li>
                            ایباس : خدمات نرم افزاری که توسط شرکت به منظور جابه جایی مسافر به کاربران ارائه میشود .
                            </li>
                            <li>
                             اپلیکیشن: نرم افزار متعلق به شرکت که به منظور استفاده از خدمات ایباس ، حق استفادۀ موقت از آن برابر
                            شرایط مندرج در قرارداد خصوصی و سند حاضر به کاربران یا طرفهای تجاری شرکت اعطا میشود .
                            </li>
                            <li>
                             قرارداد: توافق کتبی یا الکترونیکی فیمابین جهت واگذاری انحصاری و غیرقابل انتقال منافع مربوط به وسیله
                            نقلیه متعلق به مالک با مشخصات ذکرشده در پیوست شماره یک قرارداد در طول مدت قرارداد به جهت
                            بهره برداری شرکت از این منافع و در حدود شرایط و مفاد این قرارداد در راستای جابه جایی مسافران و مرسولاتی
                            که از طریق شرکت به طرف مالک ابلاغ میگردد.
                            
                            </li>
                            <li>
                             طرف دوم یا مالک : شخصی حقیقی یا حقوقی که طبق اسناد و مدارک ارائه شده مالک اتوبوس است
                             </li>
                             <li>
                             راهبران یا کارکنان : شخصی حقیقی است که از طرف مالک به نمایندگی جهت اجرا معرفی میشود تا برابر
                            شرایط شرکت و قوانین حاضر از طریق اینترنت به اپلیکیشن متصل و از خدمات ایباس بهره مند میشود .
                            </li>
                             <li>
                             کاربران: از کاربر راهبر، کاربر مسافر و کاربر مهمان یا سایر کاربران ایباس ، تحت عنوان کاربران یاد میشود .
                             </li>
                             <li>
                             کاربر مسافر: شخص حقیقی یا حقوقی است که در اپلیکیشن مسافر ایباس بلیط یا درخواستی ثبت کرده است .
                             </li>
                             <li>
                             طرف تجاری: اشخاص حقیقی و حقوقی که برابر قرارداد خصوصی از طریق ایجاد درگاه، حق بهرهبرداری موقت از
                            اپلیکیشن را با نام تجاری خود یا مشترک با ایباس دارند
                            </li>
                             <li>
                            حساب کاربری: حسابی است که اشخاص برای استفاده از خدمات ایباس در اپلیکیشن ایجاد کرده اند .
                            </li>
                             <li>
                             کد تخفیف: کد صادر و تامین اعتبار شده توسط ایباس که برابر آن کاربر مسافر می تواند با وارد کردن در
                            اپلیکیشن از پرداخت کل یا قسمتی از هزینه سفر معاف می شود .
                            </li>
                             <li>
                             موجودی: مبلغی است که کاربران در حساب کاربری خود به منظور استفاده از خدمات ایباس دارند. این مبلغ به
                            صورت پرداخت از طریق سامانۀ بانکی و کارتهای عضو شبکۀ شتاب و طبق شرایط و قوانین حاضر منظور و
                            محاسبه خواهد شد .
                            </li>
                             <li>
                             اطلاعات محرمانه: اطلاعاتی که توسط کاربران در ایباس قرار داده میشود، اعم از اطلاعاتی که به صورت مستقیم
                                از سوی کاربران وارد میشود و همچنین اطلاعاتی که به صورت خودکار و در نتیجۀ بهره برداری از خدمات ایباس
                                توسط شرکت یا طرفهای تجاری تولید یا در اختیار شرکت قرار داده میشود .
                            </li>
                             <li>
                             قوانین و مقررات جمهوری اسلامی ایران: قانون اساسی، قوانین عادی، آئین نامه های اجرایی، بخشنامه ها،
                            دستورالعمل ها و کلیه ضوابط قانونی حاکم بر انجام موضوع قرارداد اعم از قانون بیمه اجباری شخص ثالث،
                            قوانین سازمان راهداری وحمل ونقل جاده ای، آئین نامه راهنمائی و رانندگی و قانون رسیدگی به تخلفات
                            رانندگی 
                            </li>
                            </ol>
                            </p>

                            <p>
                            <b>
                            ماده - ۲ حساب کاربری
                            </b>
                            <br/>
                            <ol type="1">
                                <li>
                             کاربران در صورت نیاز به استفاده از خدمات ایباس باید برای تکمیل اطلاعات خواسته شده توسط طرف های
                            تجاری از قبیل نشانی اقدام کنند .
                            </li>
                            <li>
                             کاربران شخص حقوقی مکلف به معرفی نماینده (شخص حقیقی) برای ثبت نام در اپلیکیشن هستند و اطلاعات
                            این ش خص حقوقی باید در اپلیکیشن قید شود .
                            </li>
                            <li>
                             هیچ یک از کاربران حق استفاده از ربات و نرمافزارهای مرتبط یا واسط را برای استفاده از اپلیکیشن اعم از احراز
                            هویت، تکمیل اطلاعات، ارسال درخواست و غیره ندارند .
                            </li>
                            <li>
                             کاربران میپذیرند کلیه اطلاعات درخواستی اپلیکیشن را مطابق با واقعیت، صحیح و به روز وارد کنند و شخص
                            کاربر مسئول عدم صحت و به روز نبودن اطلاعات است. در صورت اثبات خلاف این موضوع، شرکت هیچ گونه
                            مسئولیتی در مورد خسارات و مشکلات ناشی از عدم اعتبار اطلاعات اعلامی بر عهده نخواهد داشت .
                            </li>
                            <li>
                             در شرایط خاصی ممکن است از کاربران برای استفاده از خدمات، درخواست احراز هویت شود، در این شرایط اگر
                            کاربران اطلاعات کافی در اختیار شرکت قرار ندهند، شرکت میتواند حساب کاربری آنها را مسدود و از ارائۀ
                            خدمات به نام بردگان خودداری کند .
                            </li>
                            <li>
                             کاربران حق ندارند به سایر اشخاص حقیقی و حقوقی اجازه استفاده از حساب کاربری خود را بدهند یا حساب
                            خود را به شخص حقیقی یا حقوقی دیگری منتقل کنند. در مورد کاربر شخص حقوقی نیز، مسئولیت های قانونی
                            بهره برداری از خدمات ایباس متوجه مدیران اشخاص حقوقی خواهد بود .
                            </li>
                            </ol>
                            </p>

                            <p>
                                <b>ماده - ۳ استفاده از ایباس</b>
                                <ol type="1">
                                    <li>
                                    طرف اول بر اساس شرایط روز و مصوبات، تغییرات در قیمت را از طریق پلتفرم و یا سایر روشهای در دسترس
                                    به اطلاع طرف دوم میرساند.
                                    </li>
                                    <li>. ساعت حرکت و مسیر حرکت وسیله نقلیه بر اساس زمانبندی ها و صلاحدید شرکت خواهد بود.</li>
                                    <li>در صورت آماده نبودن وسیله نقلیه به هر دلیل از جمله نقص فنی که به شرکت در زمان مقتضی اعلام کتبی نشده
                                    باشد، تمامی خسارات شرکت و مسافران بر عهده طرف دوم میباشد و شرکت میتواند وسیله نقلیه دیگری را
                                    جایگز ین نماید
                                    </li>
                                    <li>
                                    طرف دوم اقرار مینماید از کم و کیف کار کلاً و جزئاً مطلع است و آموزش های لازم جهت همکاری و بهرهبرداری
                                    از سامانه های شرکت را دارد و آگاه بر کلیه شرایط قرارداد استقرار و یا انجام تعهدات به طوری که بعداً در اجرای
                                    مفاد قرارداد هیچ گونه عذری پذیرفته نیست میباشد.
                                    </li>
                                    <li>
                                    مالک متعهد است به جهت انجام تعهدات قراردادی خود یک راننده اصلی و یک مهماندار )با هم
                                    تحت قرارداد با طرف دوم می باشند را جهت آموزشهای لازم برای بهرهبرداری از سامانه های نرم افزاری و
                                    آیین نامه های شرکت معرفی نماید. بدیهی است چنانچه به تشخیص شرکت در مسیرهایی نیاز به کارکنان مازاد
                                    بر افراد مشخص شده در این بند باشد، طرف دوم باید طبق زمانبندی اعلام شده توسط شرکت شخص موردنظر را
                                    نیز معرفی نماید.
                                    <br/>
                                    تبصره: مالک در صورت داشتن شرایط لازم میتواند خود را به عنوان یکی از افراد ذکر شده در این بند معرفی
                                    نماید .
                                    <br/>
                                    تبصره: به منظور انجام تعهدات مربوط به این ماده در طول مدت قرارداد، طرف دوم مکلف و متعهد میباشد که
                                    با کارکنان خود قرارداد مورد تایید شرکت را که در پنل اختصاصی متعلق به طرف دوم و به ضمیمه این قرارداد
                                    تنظیم شده است را با کارکنان خود منعقد و نسخه تکمیل امضا شده را در بازه زمانی 10 روز از زمان انعقاد قرارداد
                                    مذکور در پنل خود بارگذاری و نسخهای از آن را برای شرکت ارسال نماید. بدیهی است تخلف از این تبصره به
                                    شرکت حق فسخ قرارداد حاضر بودن اعلام کتبی قبلی را خواهد داد. همچین طرف دوم مکلف به پرداخت حقوق
                                    مادی کارکنان در اتمام ماموریت ها و با رعایت تعرفه دستمزد رانندگان و خدمه سفر اعلام شده از سوی انجمن
                                    صنفی رانندگان طی مدت قرارداد را پرداخت نماید.
                                    </li>
                                    <li>
                                    طرف دوم متعهد می باشد کارکنانی را به شرکت معرفی نماید که دارای صلاحیت اخلاقی بوده و مورد تایید شرکت
                                    باشند. کارکنان مکلف و ملزم به رعایت شئونات و آیین نامه های مصوب شرکت همچین رعایت تمامی نکات ایمنی
                                    و حفاظتی در حین ارایه خدمات میباشند . تأمین استاندارهای مورد نیاز و آموزشهای لازم و همچنین
                                    اطلاعرسانی شئونات و آیین نامه های مذکور در این بند به کارکنان بر عهده طرف دوم میباشد . عدم اطلاع کارکنان
                                    مسئولیت ایشان و طرف دوم بر جبران خسارات احتمالی وارده به شرکت و مسافران را ملغی نخواهد کرد. در
                                    صورت مشاهده عدم رعایت شرایط مقرر در این بند شرکت حق دارد ضمن اخذ خسارات، قرارداد را فسخ کند و
                                    تمامی مبالغ در اختیار خود را به عنوان خسارات قراردادی ضبط و از پرداخت مبالغ ماه آخر نیز جلوگیری نماید.
                                    <br/>
                                    تبصره: در صورتی که هر کدام از اشخاص معرفی شده به عنوان راننده یا مهماندار به هر دلیل و به تشخیص غیرقابل
                                    اعتراض شرکت مورد قبول شرکت نباشند، طرف دوم موظف است حداکثر ظرف مدت ۲۴ ساعت از اخطار شرکت نسبت
                                    به تعلیق و تعویض آنان اقدام نماید .
                                    </li>
                                    <li>
                                    طرف دوم متعهد است وسایل نقلیه مذکور در قرارداد را طبق مقررات راهنمایی و رانندگی، استانداردهای سازمان
                                    راهداری و حمل ونقل جادهای از نظر فنی و ایمنی بررسی و جهت مناسبسازی اقدام به اخذ گواهی های مربوطه
                                    نماید. همچین طرف دوم مکلف است وسیله نقلیه خود را طبق برنامه تنظیمی و در مسیر مورد نظر و صلاحدید
                                    شرکت که به توافق رسیده است در اختیار شرکت قرار دهد.
                                    </li>
                                    <li>
                                    خدمات طرف دوم و کارکنان و همچنین شرایط فیزیکی وسیله نقلیه می بایست از کیفیت مطلوب مورد پذیرش
                                    شرکت برخوردار باشد. در صورت مشاهده هر نقص و یا ایراد در ارايه خدمات یا شرایط فیزیکی وسیله نقلیه طرف
                                    دوم مکلف است فورا نسبت به رفع آن اقدام نماید. در صورت عدم رفع ایراد قرارداد به حالت تعلیق در آمده
                                    بدیهی است خسارت قراردادی در این بند تنها به جهت تعیین حداقل خسارات احتمالی وارده به شرکت میباشد
                                    و چنانچه شرکت خسارات مازاد بر این مبالغ را اثبات کند این خسارات مازاد نیز قابل مطالبه خواهد بود.
                                    </li>
                                    <li>
                                    طرف دوم و کارکنان متعهد هستند که یک ساعت قبل از حرکت، وسیله نقلیه خود را طبق پروتکل های نظافتی و
                                    بهداشتی ارائه شده از سوی شرکت جهت سرویس آماده نماید .
                                    </li>
                                    <li>
                                    طرف دوم و کارکنان متعهد هستند از هرگونه بی نظمی و جارکشی در سوار و پیاده کردن مسافر در حین سفر اجتناب
                                    مینمایند.
                                    </li>
                                    <li>
                                    طرف دوم و کارکنان آن متعهد به رعایت موازین و شئوونات اسلامی و حسن رفتار با مسافران و عدم
                                    استفاده و استعمال مواد یا مشروباتی که از نظر قانون جرم بوده و یا از حالت عادی خارج نماید همچنین باید از
                                    استعمال دخانیات در داخل وسیله نقلیه از جمله زمانی که در حال خدمت رسانی به مسافران می باشند خودداری
                                    نمایند.
                                    </li>
                                    <li>
                                    طرف دوم و کارکنان آن متعهد و مکلف به رعایت کلیه تعهدات مندرج در آیین نامه انضباطی شرکت به عنوان
                                    پیوست شماره سه این قرارداد هستند و در صورت تخلف شرکت مجاز خواهد بود نسبت به مطالبه آنها از طرف
                                    دوم از طریق مراجع ذی صلاح قضایی اقدام کند.
                                    <br/>
                                    تبصره: تشخیص عدم انجام هر یک از تعهدات توسط طرف دوم و یا کارکنان آن و یا بی احتیاطی در انجام هریک
                                    از آنها و نیز تعیین خسارات وارده به عهده طرف اول و کمیته انضباطی شرکت می باشد.
                                    </li>
                                    <li>
                                    تمامی مسئولیت های حقوقی و کیفری ناشی از اجرا یا عدم اجرای این قرارداد و تمامی خسارات وارده به
                                    مسافران و سرنشینان وسیله نقلیه بر عهده طرف دوم بوده و طرف اول در این خصوص هیچگونه مسئولیتی
                                    نخواهد داشت. بدیهی است چنانچه از این جهت به شرکت خساراتی وارد شود طرف دوم مکلف به جبران این
                                    خسارات میباشد.
                                    </li>
                                    <li>
                                    در صورت تخلف، تقلب و یا تقصیر طرف دوم ویا هر یک از کارکنان آن از موضوع قرارداد علاوه بر پیگرد قانونی
                                    و فسخ قرارداد توسط شرکت، طرف دوم متعهد است تمامی خسارات وارده به شرکت )اعم از اینکه مستقیماً یا
                                    توسط کارکنان آن خسارات وارد شده باشد( را جبران نماید.
                                    <br/>
                                    تبصره: حمل بار و یا مسافر ثبت نشده ویا اعلام نشده به شرکت از جمله مصادیق تقلب و تخلف از مفاد این قرارداد
                                    میباشد .
                                    </li>
                                    <li>
                                    طرف دوم و کارکنان مذکور در این قرارداد متعهد و موظف هستند تمام مسافرین اعلامی جهت سوار یا پیاده
                                    شدن در ایستگاه ذکر شده از طریق نرم افزار را اجرا نماید و یا تغییرات در تعداد مسافر حین سفر را بلافاصله به
                                    شرکت اعلام نماید. درصورت سوارکردن مسافر بین راهی و عدم اطلاع به شرکت تمام مسولیت های عدم ثبت
                                    متوجه طرف دوم و کارکنان آن میباشد .
                                    </li>
                                    <li>
                                    تمام مسولیت های حقوقی در طول سفر که در قوانین و مقررات پیشبینی گردیده به عهده طرف دوم و کارکنا ن
                                    آن میباشد .
                                    </li>
                                    <li>
                                    چنانچه در طول مدت این قرارداد طرف دوم قصد معامله و یا فروش وسیله نقلیه را داشته باشد، بایستی با
                                    اطلاع قبلی و کتبی )حداقل 45 روز قبل( به شرکت در این خصوص اقدام نماید.
                                    </li>

                                    <li>
                                    طرف دوم متعهد می گردد هرگونه تغییر در نشانی یا شماره تلفن و موبایل خود را در اسرع وقت اعلام تا مراتب
                                    در قرارداد طرفین اصلاح گردد.
                                    </li>
                                    <li>
                                    طرف دوم حق انعقاد هر گونه قرارداد با هیچ یک از اشخاص حقیقی و حقوقی دیگر به قصد جابجائی مسافر و
                                    مرسوله و نیز حق واگذاری قرارداد را کلاً و جزئاً به غیر ندارد مگر رضایت قبلی و کتبی طرف اول را گرفته باشد.
                                    </li>
                                    <li>
                                    طرف دوم متعهد است که از ابتدای قرارداد با بغل نویسی و نصب طرحهای گرافیکی که نشان دهنده این مطلب
                                    باشد که وسیله مذکور در حال همکاری با طرف اول می باشد اقدام نماید. هزینه ها و طراحی های مربوطه بر عهده
                                    شرکت خواهد بود. همچنین شرکت میتواند در طول مدت این قرارداد به دفعات نسبت به تغییر طرحها و اجرای
                                    آن با هزینه خود شرکت اقدام نماید .
                                    </li>
                                    <li>
                                    در صورتی که طرف دوم قصد ادامه همکاری به واسطه این قرارداد را نداشته باشد موظف است حداقل ۴۵ روز
                                    قبل مراتب را کتباً به طرف اول اعلام کند و در صورت موافقت کتبی طرف اول نسبت به فسخ قرارداد اقدام نماید .
                                    </li>
                                </ol>
                            </p>
                            <p>
                            <b>ماده 4 - توافق از راه دور:</b>
                            <br/>
                            با توجه به توافق از راه دور از طریق سامانههای شرکت تمام موارد ابلاغ جهت انجام سفر و شرح خدمات اعلامی جز موارد
                            لاینفک این قرارداد می باشد. بنابراین، طرف دوم توافق میکند برای مبادله آسان اطلاعات و انجام توافقات جدید، همه
                            تغییرات و الحاقیه های شرایط و قوانین حاضر اعم از تغییر و اضافه کردن شروط آن، تنظیم قراردادها، اخطاریه ها و ابلاغیه های
                            مربوط به شرکت یا طرف تجاری، اعمال حق فسخ، از طریق اپلیکیشن ایباس ) EBUS ) بهعمل آید و طرف دوم ضمن پذیرش
                            اطلاع از شرایط و روند اجرایی توافق از راه دور و به صورت الکترونیکی، موافقت خود را نسبت به اعمال هرگونه شرایط و
                            توافق جدید را از طریق فضای مجازی و به صورت الکترونیکی اعلام می کنند. طرف دوم می پذیرد هرگونه رویه، اشکال، عبارات
                            مبین تایید و اعلام قبولی و تصدیق داده پیام های صادره از طرف شرکت یا طرف تجاری به منزله امضای الکترونیکی و قبولی
                            محسوب می شود و هرگونه ادعایی نسبت به امضا و قبولی مذکور غیر قابل استماع و مردود است. طرف دوم با عضویت در
                            ایباس و استفاده از آن قصد و اراده خود را نسبت به پذیرش انعقاد هرگونه اقدام و عمل حقوقی از جمله عقود و معاملات
                            از راه دور و از طریق سامانه رایان های و الکترونیکی اعلام می کنند .
                            </p>

                            <p>
                                <b>ماده 5 - محرمانگی:</b>
                                <ol type="1">
                                    <li>
                                    هر یک از طرفین متعهد میشود که مفاد قرارداد حاضر و نیز اطلاعات و داده هایی را که از زمان شروع مذاکرات
                                    مقدماتی این قرارداد تا خاتمه قرارداد، توسط طرف دیگر به صورت مستقیم یا با واسطه نمایندگان وی، افشاء
                                    قطع نظر از آن که به صورت کتبی، شفاهی، الکترونیکی یا   طرف افشاءکننده  شده یا میشود  از این پس
                                    چندرسانهای باشد، دارای مهر محرمانه باشد یا نباشد و در خصوص حفظ، نگهداری و عدم افشا آنها هشداری
                                    تلقی نماید. در این راستا، طرف دریافت کننده اطلاعات محرمانه از  اطلاعات محرمانه  داده شده باشد یا خیر
                                    متعهد است که: ، طرف دریافت کننده  این پس
                                    <br/>
                                    الف- از افشای اطلاعات محرمانه و فراهم نمودن موجبات افشای اطلاعات محرمانه برای هر شخص حقیقی یا
                                    حقوقی به جز اشخاصی که آگاهی آنها از اطلاعات محرمانه برای اجرای قرارداد حاضر ضروری است خودداری
                                    نماید .
                                    <br/>
                                    اطلاعات محرمانه را منحصراً در راستای تأمین هدف این قرارداد و مفاد آن مورد استفاده قرار دهد، از این
                                    اطلاعات به نفع خود یا اشخاص ثالث، بهرهبرداری ننموده و از اختیار دسترسی به اطلاعات برای مقاصد شخصی
                                    و غیر کاری سوءاستفاده ننماید.
                                    <br/>
                                    تبصره: درصورتیکه طرف دریافت کننده، به واسطه دستور لازم الاجرای مقامهای قضایی و یا ضابطان دادگستری،
                                    ناچار به ارائه اطلاعات محرمانه گردد، مرتکب نقض تعهد حفظ محرمانگی مقرر در بند الف ماده ۱۱ - ۱ نشد ه است؛
                                    مشروط بر آنکه تنها آن بخش از اطلاعات محرمانه را که ضروری است، در اختیار مقا مهای قضایی و یا ضابطان
                                    دادگستری بنهد و در صورت عدم منع مقام قضایی یا ضابط مربوطه، مراتب را فوراً به اطلاع طرف افشاکننده
                                    رساند .
                                    </li>
                                    <li>
                                    طرف افشاءکننده، اطلاعات محرمانه را تنها تا حدی كه در این قرارداد به آن ملزم شده و در سایر موارد، تنها تا
                                    حدی که بنا به صلاحدید خود ضروری یا مطلوب بداند، به طرف دریافت کننده افشاء مینماید. همچنین طرف
                                    دریافت کننده، حق دارد قبل از افشای اطلاعات، از پذیرش هرگونه اطلاعات محرمانه خودداری کند. اطلاعات
                                    محرمانه ای که علیرغم امتناع طرف دریافت کننده از دریافت آن افشاء شد هاند، در قلمرو تعهدات موضوع این ماده
                                    قرار نمیگیرند.
                                    </li>
                                    <li>
                                    طرف افشاءکننده میتواند استرداد یا انهدام اطلاعات محرمانه و نسخ آن را پس از خاتمه این قرارداد درخواست
                                    نماید. استرداد یا انهدام به معنای انجام کلیه اقدامات معقول در راستای بازپسدادن و نابودسازی غیرقابل بازیابی
                                    کلیه اطلاعات محرمانه و نسخ آن است. مقررات مربوط به استرداد و انهدام، نسبت به آن بخش از اطلاعات
                                    محرمانه که طرف دریافت کننده مطابق با قوانین امری مکلف به نگهداری آنها تا موعد معین است و نیز نسبت
                                    به نسخی از اطلاعات محرمانه که به صورت مستمر جهت تهیه پشتیبان  (Backup)  ذخیره میگردد؛ اعمال نخواهد
                                    شد .
                                    </li>
                                    <li>
                                    چنانچه طرف دریافت کننده هر یک از موارد ذیل را اثبات نماید، تعهدات موضوع ماده ۱۱ - ۱ ساقط میشود :
                                    الف- در زمانی که طرف افشاءکننده، اطلاعات مذکور را در اختیار طرف دریافت کننده قرار داده و یا متعاقباً، این
                                    اطلاعات در دسترس عموم قرار گرفته است.
                                    <br/>
                                    ب- اطلاعات مذکور به صورت قانونی و بدون تعهد به رازداری از شخص ثالث دریافت شد هاست.
                                    <br/>
                                    طرف دریافت کننده یا شرکت های مرتبط با آن رأساً و به صورت مستقل از اطلاعات محرمانه، آنها را ایجاد
                                    کرده است.
                                    </li>
                                    <li>
                                    در صورتی که طرف دریافت کننده مرتکب نقض مفاد این قرارداد شود، باید اقدامات لازم را، از جمله و بدون قید
                                    محدودیت به اطلاع رسانی مراتب به طرف افشاءکننده، به منظور جلوگیری از تشدید خسارات ناشی از نقض به
                                    عمل آورده و همکاری لازم را با طرف مقابل در این زمینه اتخاذ نماید. همچنین طرف افشاءکننده میتواند علاوه
                                    بر تقاضای جبران خسارت از مرجع تعیین شده در ماده ۱۲ این قرارداد، پس از تائید نقض محرمانگی در مرجع
                                    مزبور، به صورت یکجانبه اقدام به فسخ فوری این قرارداد نماید.
                                    </li>
                                    <li>
                                    طرفین ضمن عقد خارج لازم توافق کردهاند که مفاد ماده ۱۱ حاضر، موافقت نامه ای مستقل از این قرارداد بوده و
                                    در مدت اعتبار این قرارداد و نیز به مدت دو سال پس از فسخ، انفساخ، اقاله، اعلام بطلان یا خاتمه مدت قرارداد
                                    حاضر، معتبر و لازمالاجرا خواهد بود .
                                    </li>
                                </ol>
                            </p>

                            <p>
                                <b>ماده 6 - سایر موارد:</b>
                                <p>مالک در کمال صحت عقل و اراده اقرار می نماید واجد تمامی شرایط قانونی و قراردادی نسبت به استفاده از خدمات شرکت
                                    به منظور انجام موضوع قرارداد از جمله عدم سوء پیشینه، عدم اعتیاد به مواد مخدر و مشروبات الکلی و همچنین عدم
                                    استعمال و مصرف آنها بوده و همچنین کاربران اقرار مینمایند کلیه اظهارات، اعلامات، تائیدیهها و محتویات و مندرجات
                                    اسناد و مدارک ارائه شده و اطلاعات اعلامی به شرکت و هر آنچه که در آینده اعلام و ارائه میگردد منطبق با واقع و حقیقت
                                    میباشد. در صورتیکه به هر دلیل اعم از اعلام مراجع و اشخاص خلاف اظهارات کاربران اعلام یا احراز گردد، شرکت محق
                                    میباشد ضمن غیر فعال نمودن دائمی کاربر خاطی و به جهت تخلف نامبرده از موارد فوق نسبت به مطالبۀ مبلغ 2۵۰.۰۰۰.۰۰۰
                                    ریال بعنوان خسارت و وجه التزام این شرایط و مقررات اقدام نماید. وصول تمام یا قسمتی از خسارت و وجه التزام فوق از
                                    موجودی ریالی کاربر نزد شرکت بلامانع می باشد
                                </p>
                                <ol type="1">
                                    <li>
                                    علاوه بر اصول حاکم بر تفسیر، رعایت موارد زیر در تفسیر این قرارداد مورد توافق طرفین است:
                                    <br/>
                                    الف- در تفسير هر بخش از مفاد این قرارداد، موضوع و هدف قرارداد می بایست مدنظر قرار گیرد .
                                    <br/>
                                    ب- عناوین و سرفصل های به کار رفته فقط جهت سهولت ارجاع است و تأثیری بر تفسیر مفاد ذیل آنها ندارد.
                                    <br/>
                                    ج- مطابق با ماده ۶ قانون تجارت الکترونیکی مصوب ۱۳۸۲ و مشتقات آن، ناظر به ارسال مکاتبات، کتباً ، واژه
                                    اعلامات، ابلاغات و موارد مشابه از طریق رایانامه های مورد توافق طرفین است؛ مگر در مواردی که قوانین لازم الاجرا
                                    صرفاً روش یا روشهای معین و غیرقابل عدول و تغییری را مجاز دانسته باشند.
                                    <br/>
                                    ه- هر جا كه معنای عبارت ایجاب كند، كلمات مفرد معنای جمع و كلمات جمع معنای مفرد دارد .
                                    <br/>
                                    و- طرفین تأیید و تصدیق می نمایند که فرصت لازم برای بررسی مفاد این قرارداد را داشته اند و هیچ بخش از مفاد
                                    آن نباید به دلیل تنظیم یا پیشنهاد آن توسط یکی از طرفین، به سود طرف دیگر تفسیر گردد.
                                    <br/>
                                    سایر اصطلاحات مشابه در مورد عباراتی که بلافاصله پس از آن مانند « ،» از جمله « ،» شامل اصطلاحات
                                    میآید، مفید معنای حصر نیستند .
                                    
                                    </li>
                                    <li>
                                    چنانچه بخشی از مفاد این قرارداد نامعتبر، غیرقانونی یا غیرقابل اجرا شناخته شود، این امر بر سایر مفاد این قرارداد
                                    تاثیری نداشته و سایر بخشهای قرارداد لازم الاجرا خواهد بود.
                                        
                                    </li>
                                    <li>
                                    جز در مواردی که فوریت مورد تصریح قرار گرفته است، عدم اعمال یا تأخیر در اعمال هر یک از حقوق و اختیارات
                                    ناشی از این قرارداد، به منزله انصراف از آن حقوق و اختیارات نخواهد بود و اعمال برخی از حقوق و اختیارات
                                    ناشی از این قرارداد نیز به مثابه انصراف از سایر حقوق و اختیارات یا انصراف از اعمال مجدد آنها نخواهد بود.
                                    </li>
                                </ol>

                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Conditions;